import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ConsultationUrl } from '../../../shared/urls/master-data.consultation.url';
import { PriceUrl } from '../../../shared/urls/price.url';

@Injectable()
export class ConsultationsService {
    constructor(public baseService: BaseService) {

    }
    getConsultationList(param) {
      // const url = PriceUrl.GET_PRICE_LIST;
      // return this.baseService.getData(url, param);

       const url = ConsultationUrl.CONSULTATION_GET;
       return this.baseService.getData(url, param);
    }

    getConsultation(id) {
      // const url = MasterDataUrl.GET_EMAIL_DOMAIN_BY_ID.replace('{id}', id);
      // return this.baseService.getData(url);
    }

    addNewConsultation(param) {
       const url = ConsultationUrl.CONSULTATION_ADD;
       return this.baseService.postData(url, param);
    }

    deleteConsultation(id) {
       const url = ConsultationUrl.CONSULTATION_DELETE.replace('{id}', id);
       return this.baseService.delete(url);
    }
    updateConsultation(id, param) {
       const url = ConsultationUrl.CONSULTATION_UPDATE.replace('{id}', id);
       return this.baseService.put(url, param);
    }

    getCurrencies(selectedCentre) {
      let url = PriceUrl.GET_CURRENCIES;
      let param = { selectedCentreId: selectedCentre };
      return this.baseService.getData(url, param);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/consultations/consultations.service.ts